import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    newPBServicePlan_loading: false,
    allServicePlan: null,
    filteredServicePlan:null,
    newPBServicePlan_error: null,
    newPBServicePlan_success: false
  };
  
const GetNewPrinterBundleServicePlanSlice = createSlice({
  name: 'NewPrinterBundleServicePlanSlice',
  initialState,
  reducers: {
    GetNewPBServicePlanInit(state) {
      state.newPBServicePlan_loading = true;
      state.newPBServicePlan_error = null;
      state.allServicePlan =  null;
      state.newPBServicePlan_success = false;
    },
    GetNewPBServicePlanSuccess(state, action) {
      state.newPBServicePlan_loading = false;
      state.newPBServicePlan_success = true
      state[action?.payload?.model ? 'filteredServicePlan' : 'allServicePlans'] =  action?.payload?.servicePlan;;
    },
    GetNewPBServicePlanFailure(state, action) {
      state.newPBServicePlan_loading = false;
      state.newPBServicePlan_error = action.payload;
      state.newPBServicePlan_success = false
    }
  },
});

export const { 
  GetNewPBServicePlanInit, 
  GetNewPBServicePlanSuccess, 
  GetNewPBServicePlanFailure
} = GetNewPrinterBundleServicePlanSlice.actions;

export default GetNewPrinterBundleServicePlanSlice.reducer;
